import React from "react";
import Homepage from "./Homepage";
import About from "./About";
import Projects from "./Projects";
import Footer from "./Footer";
import Contact from "./Contact";

const Main=()=>{
    return<>
     <Homepage/>
     <About/>
     <Projects/>
     <Contact/>
     <Footer/>
    
    
    </>
}
export default Main;